import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState = { accountId: null };

const accountIdSlice = createSlice({
	name: 'accountId',
	initialState,
	reducers: {
		// treat actions more as "describing events that occurred", rather than "setters".
		// https://redux.js.org/style-guide/#model-actions-as-events-not-setters
		accountIdAdded(state, action) {
			// eslint-disable-next-line no-param-reassign
			if (state) {
				return action.payload;
			}
			return state;
		}
	}
});

export const useAccountId = () => useSelector((state) => state.accountId);

export const { accountIdAdded } = accountIdSlice.actions;

export default accountIdSlice.reducer;
